export default __webpack_public_path__ + "static/media/luggage.8e3e77dd.png";